// Angular:
import { Component, HostBinding, Input } from '@angular/core';

// Dependencies:
import { isNotNull, Value } from '@trademe/ensure';
import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';
import { StepIndicatorComponent } from '../step-indicator/step-indicator.component';

@Component({
    selector: 'tm-step-indicator-tab',
    templateUrl: 'step-indicator-tab.component.html',
    standalone: false
})
export class StepIndicatorTabComponent {
    @Input() @Value(isNotNull) public item: StepIndicatorItemComponent;

    @HostBinding('class.o-step-indicator-tab') public stepIndicatorTab = true;

    constructor(private _stepIndicator: StepIndicatorComponent) {}

    public select(item: StepIndicatorItemComponent): void {
        this._stepIndicator.select(item);
    }
}
